import Vue from 'vue';
import AddLiveElement from './addLiveElement';

export const vmAddLiveElement = new Vue({
  components: { AddLiveElement },
  template: `<AddLiveElement
    :banner-value-props.sync="bannerValue"
    :plan-value-props.sync="planValue"
    :is-banner-active-props="isBannerActive"
    :is-plan-active-props="isPlanActive"
    />`,
  data () {
    return {
      bannerValue: {},
      planValue: [],
      isBannerActive: false,
      isPlanActive: false
    };
  }
});
